import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("6J1Ga"), parcelRequire.load("g56vt"), parcelRequire.load("dsIXS"), parcelRequire.load("i0M0K"), parcelRequire.load("8WlTG"), parcelRequire.load("6e0ex"), parcelRequire.load("d4VSw"), parcelRequire.load("8L9rh"), parcelRequire.load("16eHg")]).then(() => {
let originalModule = parcelRequire("i9ilt");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("6J1Ga")} />
  <link rel="modulepreload" href={parcelRequire.resolve("g56vt")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dsIXS")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("i0M0K")} />
  <link rel="modulepreload" href={parcelRequire.resolve("8WlTG")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6e0ex")} />
  <link rel="modulepreload" href={parcelRequire.resolve("d4VSw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("8L9rh")} />
  <link rel="modulepreload" href={parcelRequire.resolve("16eHg")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
